<template>
    <div class="product_list_vtwo">
        <section class="category_banner_custom" v-if="banner_image">
            <img :src="banner_image" alt=" " class="" />
        </section>

        <section class="breadcrumb-section">
            <div class="container">
                <nav aria-label="breadcrumb">
                    <ol class="breadcrumb">
                        <li class="breadcrumb-item">
                            <router-link to="/">Home</router-link>
                        </li>
                        <li class="breadcrumb-item">
                            <router-link :to="{ name: 'Brands' }">
                                Brands
                            </router-link>
                        </li>
                        <li class="breadcrumb-item active" aria-current="page">
                            {{ brand_title | capitalize }}
                        </li>
                    </ol>
                </nav>
            </div>
        </section>

        <section class="cmn-section item-category-list pt-0">
            <div class="container">
                <div class="row">
                    <div class="col-md-12">
                        <div class="section_heading_box">
                            <h1
                                class="heading1 section_heading position-relative text-center mb-0"
                            >
                                <span class="bg_secondary_white px_40">
                                    {{ brand_title | capitalize }}
                                </span>
                            </h1>
                            <h3 class="sub_heading1 text-center mt_6 mb-0">
                                Our Best Selling Items
                            </h3>
                        </div>
                    </div>
                    <div class="col-md-12">
                        <div class="float-right short_by">
                            <div
                                v-show="product_list.length > 0"
                                class="select_option sec_opt"
                            >
                                <label>Sort by</label>
                                <fieldset>
                                    <v-select
                                        label="label"
                                        :reduce="(sorting) => sorting.value"
                                        v-model="listConfig.sorting"
                                        :options="sorting_array"
                                        :placeholder="'sort by'"
                                        @input="getProducts(true)"
                                    ></v-select>
                                </fieldset>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-12 apparel">
                        <div
                            class="row"
                            v-if="$route.params.product_type == '4'"
                        >
                            <div
                                class="col-md-12 col-lg-12 col-xl-12 mt-5 mt-lg-0"
                            >
                                <div class="row">
                                    <div
                                        class="col-md-6 col-lg-6 col-xl-3"
                                        v-for="(product, key) in product_list"
                                        :key="'product' + key"
                                    >
                                        <div class="product promodetails">
                                            <div
                                                class="product_image d-flex justify-content-center bg_primary_light_white py_30 position-relative"
                                            >
                                                <router-link
                                                    :to="{
                                                        name: 'product_details_new',
                                                        params: {
                                                            id_of_product:
                                                                product.id
                                                        }
                                                    }"
                                                >
                                                  <DiscountOffer
                                                        :product="product"
                                                    />
                                                    <img
                                                        :src="
                                                            product.product_default_image
                                                        "
                                                    />
                                                    <!-- <DisplayProductImage :product="product" :classValue="'img-fluid'" /> -->
                                                </router-link>
                                                

                                                <div class="absolute-tittle">
                                                   
                                                    <div class="font_size_20">
                                                        {{
                                                            product.name
                                                                | capitalize
                                                        }}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div
                                        class="col-md-12 col-lg-12 col-xl-12 align-self-center text-center"
                                        v-show="
                                            product_list.length < 1 && !isBusy
                                        "
                                    >
                                        <div class="product mb-0">
                                            <h3>No results found.</h3>
                                        </div>
                                    </div>
                                </div>
                                <div v-if="product_list.length">
                                    <b-pagination
                                        v-show="category_length > itemsPerPage"
                                        v-model="currentPage"
                                        :total-rows="category_length"
                                        :per-page="itemsPerPage"
                                        class="imprint_pagination"
                                    ></b-pagination>
                                </div>
                            </div>
                        </div>
                        <div class="row" v-else>
                            <!-- Side Bar Start Here -->
                            <!-- <ProductAttributeFilters :prod_attr_values="prod_attr_values" @updateAttrFilters="getProductsByFilters" /> -->
                            <div class="col-md-12 col-lg-4 col-xl-2">
                                <div class="side_bar filter">
                                    <div class="categorys">
                                        <div
                                            class="accordion"
                                            id="accordionExample"
                                        >
                                            <div
                                                v-if="
                                                    applied_filters.length > 0
                                                "
                                            >
                                                <div>
                                                    <button
                                                        class="category_link w-100 d-flex"
                                                        style="cursor: default"
                                                        type="button"
                                                    >
                                                        <span
                                                            >Applied
                                                            Facets</span
                                                        >
                                                    </button>
                                                </div>
                                                <div
                                                    class="category_checkbox_show"
                                                >
                                                    <div
                                                        class="category_checkbox"
                                                    >
                                                        <div
                                                            class="form-check pl_8 py_6"
                                                            v-for="(
                                                                filter, index
                                                            ) in applied_filters"
                                                            :key="index"
                                                        >
                                                            <label
                                                                class="checkbox_custom p-0 d-table"
                                                            >
                                                                <img
                                                                    @click="
                                                                        removeAppliedFilters(
                                                                            filter
                                                                        )
                                                                    "
                                                                    src="/maincss/images/cross_red_circle.png"
                                                                    width="15"
                                                                    class="mr-1"
                                                                />
                                                                <span
                                                                    style="
                                                                        cursor: default;
                                                                    "
                                                                    >{{
                                                                        filter.option_label
                                                                            | capitalize
                                                                    }}</span
                                                                >
                                                            </label>
                                                        </div>
                                                        <a
                                                            @click="
                                                                clearFilters(
                                                                    'all'
                                                                )
                                                            "
                                                            class="font_size_13 text-danger btn_link mt_14 pl_8"
                                                        >
                                                            Clear All
                                                        </a>
                                                    </div>
                                                </div>
                                            </div>

                                            <!-- Categories -->
                                            <AttributeFilter
                                                id="Categories"
                                                name="Categories"
                                                index="Categories"
                                                type="categoryIds"
                                                option-label="title"
                                                :active="true"
                                                :options="
                                                    prod_attr_values.category_list
                                                "
                                                :show-more-options="
                                                    iscategoryShowMore
                                                "
                                                :config="listConfig"
                                                @clearFilters="clearFilters"
                                                @filterProducts="filterProducts"
                                                @showMore="
                                                    showMore(
                                                        'iscategoryShowMore'
                                                    )
                                                "
                                            />

                                            <!-- COLOR SHADES -->
                                            <AttributeFilter
                                                id="ColorShades"
                                                name="Colors"
                                                index="ColorShades"
                                                type="colorShades"
                                                :storeKey="'name'"
                                                :options="
                                                    prod_attr_values.color_shades_list
                                                "
                                                :show-more-options="
                                                    iscolorShadesShowMore
                                                "
                                                :config="listConfig"
                                                @clearFilters="clearFilters"
                                                @filterProducts="filterProducts"
                                                @showMore="
                                                    showMore(
                                                        'iscolorShadesShowMore'
                                                    )
                                                "
                                            />

                                            <!-- SIZE GROUPS -->
                                            <!-- <AttributeFilter 
                                                id="SizeGroupings"
                                                name="Size Groupings" 
                                                index="SizeGroupings"
                                                type="size_groupings"
                                                :options="prod_attr_values.gender_age_list"
                                                option-label="gender"
                                                :show-more-options="isgenderAgeShowMore"
                                                :config="listConfig"
                                                @clearFilters="clearFilters"
                                                @filterProducts="filterProducts"
                                                @showMore="showMore('isgenderAgeShowMore')"
                                            /> -->

                                            <!-- SIZES -->
                                            <AttributeFilter
                                                id="Sizes"
                                                name="Sizes"
                                                index="Sizes"
                                                type="sizeIds"
                                                :options="
                                                    prod_attr_values.sizes_list
                                                "
                                                option-label="size"
                                                :show-more-options="
                                                    issizesShowMore
                                                "
                                                :config="listConfig"
                                                @clearFilters="clearFilters"
                                                @filterProducts="filterProducts"
                                                @showMore="
                                                    showMore('issizesShowMore')
                                                "
                                            />

                                            <!-- PRICES -->
                                            <!-- <AttributeFilter 
                                                id="Prices"
                                                name="Prices" 
                                                index="Prices"
                                                type="priceRanges"
                                                :options="prod_attr_values.price_ranges"
                                                :show-more-options="ispricesShowMore"
                                                :config="listConfig"
                                                @clearFilters="clearFilters"
                                                @filterProducts="filterProducts"
                                                @showMore="showMore('ispricesShowMore')"
                                            /> -->

                                            <!-- ATTRIBUTES -->
                                            <div
                                                v-for="(
                                                    attribute, attribute_index
                                                ) in prod_attr_values.attributes_list"
                                                :key="attribute_index"
                                            >
                                                <AttributeFilter
                                                    :id="`Attribute-${attribute.id}`"
                                                    :name="
                                                        attribute.attribute_name
                                                    "
                                                    :index="attribute_index"
                                                    :options="
                                                        attribute.AttributeOptions
                                                    "
                                                    :show-more-options="
                                                        attribute.show_more
                                                    "
                                                    :config="listConfig"
                                                    type="attribute_options"
                                                    option-label="category"
                                                    @clearFilters="clearFilters"
                                                    @filterProducts="
                                                        filterProducts
                                                    "
                                                    @showMore="
                                                        showMore(attribute)
                                                    "
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <!-- Side Bar End Here -->
                            <div class="col-md-12 col-lg-8 col-xl-10">
                                <ProductListGrid
                                    :product_object="product_list"
                                ></ProductListGrid>

                                <div
                                    class="pagination_margin productlist_pagination_custom"
                                >
                                    <b-pagination
                                        v-show="category_length > itemsPerPage"
                                        v-model="currentPage"
                                        :total-rows="category_length"
                                        :per-page="itemsPerPage"
                                        class="imprint_pagination"
                                    ></b-pagination>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="preloader" v-show="isBusy">
                    <div class="preloader-body">
                        <svg width="40" height="40" viewBox="0 0 40 40">
                            <polygon
                                class="rect"
                                points="0 0 0 40 40 40 40 0"
                            ></polygon>
                        </svg>
                    </div>
                </div>
            </div>
        </section>
    </div>
</template>

<script>
import { mapGetters } from "vuex";
import ApiService from "@/common/api.service";
import DiscountOffer from "@/components/DiscountOfferNew";
// import DisplayProductImage from "@/components/DisplayProductImageNew";
import ProductListGrid from "./ProductListGrid";
// import ProductAttributeFilters from "./ProductAttributeFilters";
import AttributeFilter from "@/components/AttributeFilter";

export default {
    name: "BrandProductList",
    components: {
        ProductListGrid,
        DiscountOffer,
        // DisplayProductImage,
        // ProductAttributeFilters,
        AttributeFilter
    },
    data() {
        const itemsPerPage = 20;
        const initialPage = Number(this.$route.query.page) > 0
            ? Number(this.$route.query.page)
            : 1;
        return {
            brand_title: "Brand",
            brand_data: [],
            sorting_array: [
                { label: "Relevance", value: "" },
                { label: "New", value: "new" },
                { label: "Price, High to Low", value: "price_desc" },
                { label: "Price, Low to High", value: "price_asc" },
                { label: "Name A to Z", value: "name_asc" },
                { label: "Name Z to A", value: "name_desc" }
            ],
            filter: null,
            isBusy: false,
            isbrandShowMore: false,
            iscategoryShowMore: false,
            isgenderAgeShowMore: false,
            iscolorsShowMore: false,
            isattributesShowMore: false,
            issizesShowMore: false,
            ispricesShowMore: false,
            iscolorShadesShowMore: false,
            category_list: [],
            product_list: [],
            product_list_ids: [],
            brand_list: [],
            gender_age_list: [],
            sleeve_list: [],
            style_category_list: [],
            fabric_list: [],
            color_list: [],
            attribute_list: [],
            productTypeName: "Search",
            productTypePath: "/",
            applied_filters: [],
            itemsPerPage,
            listConfig: {
                offset: (initialPage - 1) * itemsPerPage,
                limit: itemsPerPage,
                sortBy: "",
                order: "ASC",
                brandIds: [],
                sizeIds: [],
                colorIds: [],
                colorShades: [],
                categoryIds: [],
                priceRanges: [],
                size_groupings: [],
                attribute_options: [],
                searchKeyword: "",
                pms: ""
            },
            listConfigCategory: {
                sortBy: "",
                order: "ASC",
                prod_type_id: this.$route.params.product_type,
                category_id: this.$route.params.brand_id
            },
            category_length: 0,
            currentPage: initialPage,
            category_id: this.$route.params.brand_id,
            brand_id: this.$route.params.brand_id,
            banner_image: null,
            refresh_filters_data: true,
            prod_attr_ids: {
                colors_ids: [],
                size_ids: [],
                brand_ids: [],
                size_groupings_ids: [],
                category_ids: [],
                attribute_ids: [],
                attribute_option_ids: []
            },
            prod_attr_values: {
                color_shades_list: [],
                color_list: [],
                gender_age_list: [],
                sizes_list: [],
                brands_list: [],
                category_list: [],
                attributes_list: [],
                price_ranges: [
                    { id: 1, from: 0, to: 9.99 },
                    { id: 2, from: 10, to: 19.99 }
                ]
            },
            original_sizes_list: [],
            price_range: 4.99,
            sidebar: {
                show: true,
                class: "col-md-12 col-lg-4 col-xl-3"
            },
            common_size_groups: [
                {
                    id: "XS-XL",
                    size: "XS-XL",
                    sizes: ["XS", "S", "M", "L", "XL"]
                },
                {
                    id: "7XL-10XL",
                    size: "7XL-10XL",
                    sizes: ["7XL", "8XL", "9XL", "10XL"]
                }
            ],
            shirt_sizes: [
                "XS-XL",
                "XS",
                "S",
                "M",
                "L",
                "XL",
                "XXL",
                "2XL",
                "3XL",
                "4XL",
                "5XL",
                "6XL",
                "7XL",
                "8XL",
                "9XL",
                "10XL",
                "7XL-10XL",
                "11XL",
                "12XL",
                "13XL",
                "14XL",
                "OSFM",
                "YXS",
                "YS",
                "YM",
                "YL",
                "YXL",
                "1T",
                "2T",
                "3T",
                "4T",
                "5T",
                "6T",
                "LT",
                "XLT",
                "2XLT",
                "3XLT",
                "4XLT"
            ],
            filters_count: {},
            query_attributes_loaded: false,
            all_colors_list: [],
            markup_tiers: []
        };
    },
    async beforeMount() {
        await this.getAllMarkupTiers();
    },
    mounted() {
        // Get Brand Data
        this.getBrandData();
        document.body.classList.remove("bg_primary_light_white");
        var _this = this;
        _this.onLoadPage();
        _this.listConfig.category_id = "";
        _this.listConfig.prod_type_id = "";
        _this.listConfig.brand_id = _this.brand_id;
        _this.productTypeName = "Brands";
        _this.productTypePath =
            "/product-list/brand/" + _this.$route.params.brand_id;
        if (_this.$route.params.product_type == "brand") {
            console.log("");
        } else {
            _this.productTypeName = "Search";
            _this.productTypePath = "/product-list/all/all";
        }
    },
    computed: {
        ...mapGetters([
            "isAuthenticatedClient",
            "currentUserClient",
            "printTemplates",
            "embroideryTemplates"
        ]),
        pages() {
            if (this.category_length <= this.itemsPerPage) {
                return [1];
            }
            return [
                ...Array(
                    Math.ceil(this.category_length / this.itemsPerPage)
                ).keys()
            ].map((e) => e + 1);
        }
    },
    watch: {
        currentPage(newValue) {
            this.listConfig.offset = (newValue - 1) * this.itemsPerPage;
            this.getProducts();
        }
    },
    methods: {
        async onLoadPage() {
            await this.getAllColors();
            this.onloadPrepareQueryFilters();
        },
        getProducts(pagereset = false) {
            var _this = this;
            _this.isBusy = true;
            new Promise((resolve, reject) => {
                if (pagereset) {
                    _this.currentPage = 1;
                    _this.listConfig.offset = 0;
                }

                let common_size_group_ids = _this.common_size_groups.map(
                    (size_group) => size_group.id
                );
                const params = JSON.parse(JSON.stringify(_this.listConfig));
                params["sizeIds"] = params["sizeIds"].filter(
                    (sizeId) => !common_size_group_ids.includes(sizeId)
                );

                ApiService.post("/get-product-list", params)
                    .then(async ({ data }) => {
                        _this.category_length = data.products.count;
                        _this.product_list = data.products.rows;
                        _this.product_list = data.products.rows.filter(
                            (product) => product.MainNewSubProducts.length > 0
                        );

                        if (
                            !this.query_attributes_loaded ||
                            !this.listConfig.colorShades.length
                        ) {
                            this.prod_attr_values.color_shades_list = [];
                        }
                        this.filters_count["colorShades"] = {};
                        this.filters_count["colorShadeColors"] = {};

                        if (
                            !this.query_attributes_loaded ||
                            !this.listConfig.sizeIds.length
                        ) {
                            this.prod_attr_ids["size_ids"] = [];
                        }
                        this.filters_count["sizes"] = {};

                        if (
                            !this.query_attributes_loaded ||
                            !this.listConfig.size_groupings.length
                        ) {
                            this.prod_attr_ids["size_groupings_ids"] = [];
                        }
                        if (
                            !this.query_attributes_loaded ||
                            !this.listConfig.categoryIds.length
                        ) {
                            this.prod_attr_ids["category_ids"] = [];
                        }
                        this.filters_count["categories"] = {};

                        this.filters_count["priceRanges"] = {};

                        if (
                            !this.query_attributes_loaded ||
                            !this.listConfig.attribute_options.length
                        ) {
                            this.prod_attr_ids["attribute_ids"] = [];
                            this.prod_attr_ids["attribute_option_ids"] = [];
                        }
                        this.filters_count["attributes"] = {};

                        this.preparePriceRanges();
                        this.prepareFiltersCount();

                        this.product_list.forEach((product) => {
                            product["default_color_id"] = null;
                            let sub_product = product.MainNewSubProducts.find(
                                (sub_product) => sub_product.default_selection
                            );
                            if (sub_product) {
                                product["default_color_id"] =
                                    sub_product.color_id;
                            }
                            let color_ids = product.color_ids
                                ? JSON.parse(product.color_ids)
                                : [];
                            product.colors = this.all_colors_list.filter(
                                (color) => color_ids.includes(color.id)
                            );

                            // DECORATION PRICES
                            if (
                                product.decoration_price_type == "global_price"
                            ) {
                                product.price_markup_percentage =
                                    this.getMarkupFromTier(
                                        product.price_base,
                                        product.decoration_type,
                                        product.decoration_price_template
                                    );
                                product.price_markup_value =
                                    (parseFloat(product.price_base) *
                                        parseFloat(
                                            product.price_markup_percentage
                                        )) /
                                    100;
                                if (product.decoration_type == 1) {
                                    let decoration_price_template =
                                        this.printTemplates.find(
                                            (template) =>
                                                template.id ==
                                                product.decoration_price_template
                                        );
                                    if (decoration_price_template) {
                                        product.PrintTemplate =
                                            decoration_price_template;
                                        product.price_color_category_dark =
                                            decoration_price_template.price_dark;
                                        product.price_color_category_light =
                                            decoration_price_template.price_light;
                                        product.price_decoration_bulk =
                                            JSON.stringify({
                                                print_location1:
                                                    decoration_price_template.PrintLocation1Templates
                                            });
                                    }
                                } else if (product.decoration_type == 2) {
                                    let decoration_price_template =
                                        this.embroideryTemplates.find(
                                            (template) =>
                                                template.id ==
                                                product.decoration_price_template
                                        );
                                    if (decoration_price_template) {
                                        product.EmbroideryTemplate =
                                            decoration_price_template;
                                        product.price_color_category_dark =
                                            decoration_price_template.price_dark;
                                        product.price_color_category_light =
                                            decoration_price_template.price_light;
                                        product.price_decoration_bulk =
                                            JSON.stringify(
                                                decoration_price_template.EmbroideryQuantities
                                            );
                                    }
                                }
                            }

                            _this.getProductAttrIds(product);
                        });

                        // Show / Hide Sidebar
                        if (_this.product_list.length > 0) {
                            _this.sidebar.show = true;
                            _this.sidebar.class = "col-md-12 col-lg-4 col-xl-3";
                        } else {
                            _this.sidebar.show = false;
                        }

                        this.prod_attr_values.price_ranges.forEach((price) => {
                            price.products_count =
                                this.filters_count["priceRanges"][price.id] ||
                                0;
                        });

                        // Get Product Attributes
                        await _this.getAllFilterValues();

                        if (!_this.query_attributes_loaded) {
                            _this.onloadPrepareQueryAppliedFacets();
                        }
                        _this.prepareQueryParamsOnRoute();

                        _this.query_attributes_loaded = true;

                        _this.isBusy = false;
                        resolve(data);
                    })
                    .catch((response) => {
                        console.log(response);
                        reject(response);
                    });
            });
        },
        getAllMarkupTiers() {
            return new Promise((resolve, reject) => {
                ApiService.get("/get-markup-tiers")
                    .then(({ data }) => {
                        if (data.error) {
                            this.$toast.error(data.error, {
                                position: "top-right",
                                queue: true
                            });
                            return;
                        }
                        this.markup_tiers = data.markup_tiers;
                        resolve(data);
                    })
                    .catch((response) => {
                        reject(response);
                    });
            });
        },
        getMarkupFromTier(price, decoration_type, decoration_price_template) {
            let markup = 0;
            let tier = this.markup_tiers.find(
                (tier) =>
                    decoration_type == tier.decoration_id &&
                    decoration_price_template == tier.template_id &&
                    parseFloat(tier.start_price) <= parseFloat(price) &&
                    parseFloat(tier.end_price) >= parseFloat(price)
            );
            if (tier) {
                markup = tier.markup;
            }
            return markup;
        },
        getSingleMenu() {
            let params = {
                slug: "brands",
                sub_item_id: this.$route.params.brand_id
            };
            if (this.$route.params.filter_text) {
                if (this.$route.params.filter == "styles") {
                    params["nest_item_name"] = this.$route.params.filter_text;
                } else {
                    params["nest_item_id"] = this.$route.params.filter_text;
                }
            }
            return new Promise((resolve, reject) => {
                ApiService.post("/get-single-menu", params)
                    .then(({ data }) => {
                        if (data.menu_data) {
                            this.listConfig.prod_type_id = data.menu_data.id;
                            this.listConfigCategory.prod_type_id =
                                this.listConfig.prod_type_id;
                            if (this.$route.params.filter_text) {
                                this.banner_image = data.nest_menu_data
                                    ? data.nest_menu_data.banner_image
                                    : null;
                            } else {
                                this.banner_image = data.sub_menu_data
                                    ? data.sub_menu_data.banner_image
                                    : null;
                            }
                        }
                        resolve(data);
                    })
                    .catch((response) => {
                        console.log(response);
                        reject(response);
                    });
            });
        },
        getBrandData() {
            let _this = this;
            new Promise((resolve, reject) => {
                ApiService.get("/get-brand/" + _this.brand_id)
                    .then(({ data }) => {
                        _this.brand_data = data.brand;
                        _this.brand_id = data.brand.id;
                        _this.listConfig.brand_id = data.brand.id;
                        _this.brand_title = data.brand.name;
                        _this.getProducts();
                        _this.getSingleMenu();
                        resolve(data);
                    })
                    .catch(({ response }) => {
                        console.log(response);
                        reject(response);
                    });
            });
        },
        showMore(attribute) {
            if (typeof attribute == "string") {
                this[attribute] = this[attribute] ? false : true;
                return;
            } else {
                attribute.show_more = attribute.show_more ? false : true;
            }
            this.$forceUpdate();
        },
        getAllFilterValues() {
            var _this = this;
            return new Promise((resolve, reject) => {
                ApiService.post("/get-product-attributes", {
                    prod_attr_ids: _this.prod_attr_ids
                })
                    .then(({ data }) => {
                        _this.prod_attr_values.category_list = data.categories;
                        _this.prod_attr_values.category_list.forEach(
                            (category) => {
                                category.products_count =
                                    this.filters_count["categories"][
                                        category.id
                                    ] || 0;
                            }
                        );

                        _this.prod_attr_values.attributes_list =
                            data.attributes;
                        _this.prod_attr_values.attributes_list.forEach(
                            (attribute) => {
                                attribute.AttributeOptions.forEach((option) => {
                                    option.products_count =
                                        this.filters_count["attributes"][
                                            option.id
                                        ] || 0;
                                });
                            }
                        );

                        _this.prod_attr_values.sizes_list = [];
                        let sizes_list = data.sizes;
                        _this.original_sizes_list = data.sizes;
                        const sorted_size_names = _this.sizesArrangmentSorting(
                            sizes_list.map((size) => size.size)
                        );
                        let sorted_size_objs = [];
                        sorted_size_names.forEach((sorted_size_name) => {
                            sizes_list.forEach((random_size) => {
                                if (random_size.size == sorted_size_name) {
                                    sorted_size_objs.push(random_size);
                                }
                            });
                        });
                        sorted_size_objs.forEach((size) => {
                            const common_size_group =
                                this.common_size_groups.find((size_group) =>
                                    size_group.sizes.includes(size.size)
                                );
                            if (common_size_group) {
                                const index =
                                    _this.prod_attr_values.sizes_list.findIndex(
                                        (size) =>
                                            size.id == common_size_group.id
                                    );
                                if (index == -1) {
                                    _this.prod_attr_values.sizes_list.push(
                                        common_size_group
                                    );
                                }
                            } else {
                                _this.prod_attr_values.sizes_list.push(size);
                            }
                        });

                        _this.prod_attr_values.sizes_list.forEach((size) => {
                            size.products_count = 0;
                            if (size.sizes) {
                                let original_size_ids = data.sizes
                                    .filter((sizes) =>
                                        size.sizes.includes(sizes.size)
                                    )
                                    .map((sizeData) => sizeData.id);
                                let product_ids = [];
                                original_size_ids.forEach((id) => {
                                    product_ids = product_ids.concat(
                                        this.filters_count["sizes"][id] || []
                                    );
                                });
                                product_ids = [...new Set(product_ids)];
                                size.products_count = product_ids.length;
                            } else {
                                if (this.filters_count["sizes"][size.id]) {
                                    size.products_count =
                                        this.filters_count["sizes"][size.id]
                                            .length || 0;
                                }
                            }
                        });
                        resolve(data);
                    })
                    .catch((response) => {
                        console.log(response);
                        reject(response);
                    });
            });
        },
        upperCaseFirst(str) {
            return str.charAt(0).toUpperCase() + str.substring(1).toLowerCase();
        },
        clearFilters(type = "all", id = null) {
            if (type == "all") {
                this.applied_filters.forEach((filter) => {
                    this.listConfig[filter.config_type] = [];
                });
                this.listConfig["colorIds"] = [];
                this.listConfig["pms"] = "";
                this.applied_filters = [];
            } else if (type == "attribute_options") {
                const removableOptionIds = this.applied_filters
                    .filter((filter) => filter.attribute_id == id)
                    .map((filter) => filter.option_id);
                this.listConfig[type] = this.listConfig[type].filter(
                    (filterId) => !removableOptionIds.includes(filterId)
                );
                this.applied_filters = this.applied_filters.filter(
                    (filter) => filter.attribute_id != id
                );
            } else if (type == "colorShades") {
                this.listConfig[type] = [];
                this.listConfig["colorIds"] = [];
                this.applied_filters = this.applied_filters.filter(
                    (filter) => filter.attribute_id != id
                );
            } else {
                this.listConfig[type] = [];
                this.applied_filters = this.applied_filters.filter(
                    (filter) => filter.attribute_id != id
                );
            }
            this.refresh_filters_data = type == "all";
            this.getProducts(true);
        },
        removeAppliedFilters(filter) {
            this.applied_filters = this.applied_filters.filter(
                (appliedFilter) =>
                    !(
                        appliedFilter.attribute_id == filter.attribute_id &&
                        filter.option_id == appliedFilter.option_id
                    )
            );
            if (filter.config_type == "priceRanges") {
                this.listConfig[filter.config_type] = this.listConfig[
                    filter.config_type
                ].filter((config) => config.id != filter.option_id);
            } else if (filter.config_type == "sizeIds") {
                const common_size_group = this.common_size_groups.find(
                    (size_group) => size_group.id == filter.option_id
                );
                if (common_size_group) {
                    let size_ids = this.original_sizes_list
                        .filter((size) =>
                            common_size_group.sizes.includes(size.size)
                        )
                        .map((size) => size.id);
                    this.listConfig[filter.config_type] = this.listConfig[
                        filter.config_type
                    ].filter((sizeId) => !size_ids.includes(sizeId));
                }
                this.listConfig[filter.config_type] = this.listConfig[
                    filter.config_type
                ].filter((configId) => configId != filter.option_id);
            } else if (filter.config_type == "colorShades") {
                this.listConfig[filter.config_type] = this.listConfig[
                    filter.config_type
                ].filter((configId) => configId != filter.option_id);
                let shade = this.prod_attr_values.color_shades_list.find(
                    (shade) => shade.name == filter.option_id
                );
                let unchecked_shade_colors = shade.colors.map(
                    (color) => color.id
                );
                this.listConfig["colorIds"] = this.listConfig[
                    "colorIds"
                ].filter(
                    (colorId) =>
                        !unchecked_shade_colors.includes(parseInt(colorId))
                );
            } else if (filter.config_type == "pms") {
                this.listConfig[filter.config_type] = "";
            } else {
                this.listConfig[filter.config_type] = this.listConfig[
                    filter.config_type
                ].filter((configId) => configId != filter.option_id);
            }
            this.refresh_filters_data = false;
            this.getProducts(true);
        },
        filterProducts(event, value, type, attributeId, option_label) {
            if (type == "priceRanges") {
                if (event.target.checked == true) {
                    this.listConfig[type].push(value);
                    this.applied_filters.push({
                        option_id: value.id,
                        config_type: type,
                        attribute_id: attributeId,
                        option_label: `$${value.from} - $${value.to}`
                    });
                } else {
                    this.listConfig[type] = this.listConfig[type].filter(
                        (option) => option.id != value.id
                    );
                    this.applied_filters = this.applied_filters.filter(
                        (filter) =>
                            !(
                                filter.attribute_id == attributeId &&
                                value.id == filter.option_id
                            )
                    );
                }
                this.listConfig[type] = [...new Set(this.listConfig[type])];
            } else if (type == "sizeIds") {
                const common_size_group = this.common_size_groups.find(
                    (size_group) => size_group.size == value
                );
                // console.log(common_size_group)
                if (event.target.checked == true) {
                    if (common_size_group) {
                        let size_ids = this.original_sizes_list
                            .filter((size) =>
                                common_size_group.sizes.includes(size.size)
                            )
                            .map((size) => size.id);
                        this.listConfig[type] =
                            this.listConfig[type].concat(size_ids);
                    }
                    this.listConfig[type].push(value);
                    this.applied_filters.push({
                        option_id: value,
                        config_type: type,
                        attribute_id: attributeId,
                        option_label
                    });
                } else {
                    if (common_size_group) {
                        let size_ids = this.original_sizes_list
                            .filter((size) =>
                                common_size_group.sizes.includes(size.size)
                            )
                            .map((size) => size.id);
                        this.listConfig[type] = this.listConfig[type].filter(
                            (sizeId) => !size_ids.includes(sizeId)
                        );
                    }
                    this.listConfig[type] = this.listConfig[type].filter(
                        (option) => option != value
                    );
                    this.applied_filters = this.applied_filters.filter(
                        (filter) =>
                            !(
                                filter.attribute_id == attributeId &&
                                value == filter.option_id
                            )
                    );
                }
                this.listConfig[type] = [...new Set(this.listConfig[type])];
            } else if (type == "pms") {
                let filter_index = this.applied_filters.findIndex(
                    (filter) => filter.config_type == "pms"
                );
                if (event.target.checked == true) {
                    if ((!value || !value.trim()) && filter_index >= 0) {
                        this.removeAppliedFilters(
                            this.applied_filters[filter_index]
                        );
                        return;
                    } else if (
                        (!value || !value.trim()) &&
                        filter_index == -1
                    ) {
                        return;
                    }

                    if (filter_index >= 0) {
                        this.applied_filters[filter_index]["option_label"] =
                            value.trim();
                    } else {
                        this.applied_filters.push({
                            option_id: "pms",
                            config_type: "pms",
                            attribute_id: "pms",
                            option_label: value.trim()
                        });
                    }
                    this.listConfig[type] = value.trim();
                } else {
                    this.removeAppliedFilters(
                        this.applied_filters[filter_index]
                    );
                }
            } else {
                if (event.target.checked == true) {
                    if (!this.listConfig[type].includes(value)) {
                        this.listConfig[type].push(value);
                    }
                    if (
                        !this.applied_filters.find(
                            (filter) => filter.option_id == value
                        )
                    ) {
                        this.applied_filters.push({
                            option_id: value,
                            config_type: type,
                            attribute_id: attributeId,
                            option_label
                        });
                    }
                    if (type == "colorShades") {
                        if (this.listConfig["colorIds"].length == 0) {
                            let shade =
                                this.prod_attr_values.color_shades_list.find(
                                    (shade) => shade.name == value
                                );
                            let shade_color_ids = shade.colors.map(
                                (color) => color.id
                            );
                            this.listConfig["colorIds"] = [
                                ...new Set(
                                    this.listConfig["colorIds"].concat(
                                        shade_color_ids
                                    )
                                )
                            ];
                        }
                    }
                } else {
                    this.listConfig[type] = this.listConfig[type].filter(
                        (option) => option != value
                    );
                    this.applied_filters = this.applied_filters.filter(
                        (filter) =>
                            !(
                                filter.attribute_id == attributeId &&
                                value == filter.option_id
                            )
                    );
                    if (type == "colorShades") {
                        let shade =
                            this.prod_attr_values.color_shades_list.find(
                                (shade) => shade.name == value
                            );
                        let unchecked_shade_colors = shade.colors.map(
                            (color) => color.id
                        );
                        this.listConfig["colorIds"] = this.listConfig[
                            "colorIds"
                        ].filter(
                            (colorId) =>
                                !unchecked_shade_colors.includes(
                                    parseInt(colorId)
                                )
                        );
                    }
                }
                this.listConfig[type] = [...new Set(this.listConfig[type])];
            }
            this.refresh_filters_data = false;
            this.getProducts(true);
        },
        preparePriceRanges() {
            let highestPrice = 0;
            this.product_list.forEach((product) => {
                if (
                    parseFloat(highestPrice) <
                    parseFloat(product.lowest_base_price)
                ) {
                    highestPrice = parseFloat(product.lowest_base_price) + 1;
                }
            });
            if (!this.listConfig.priceRanges.length) {
                let priceRanges = [];
                let currentRange = 0;
                const rangeSize = this.price_range;

                let i = 0;
                while (currentRange < highestPrice) {
                    const rangeStart = currentRange;
                    const rangeEnd = Math.min(
                        currentRange + rangeSize,
                        highestPrice
                    );
                    priceRanges.push({
                        id: i + 1,
                        from: parseFloat(rangeStart).toFixed(2),
                        to: parseFloat(rangeEnd).toFixed(2)
                    });
                    currentRange += rangeSize + 0.01;
                    i++;
                }
                this.prod_attr_values.price_ranges = priceRanges;
            }
        },
        prepareFiltersCount() {
            this.product_list.forEach((product) => {
                // BRAND COUNT

                if (!this.filters_count["brands"]) {
                    this.filters_count["brands"] = { [product.brand_id]: 1 };
                } else if (!this.filters_count["brands"][product.brand_id]) {
                    this.filters_count["brands"][product.brand_id] = 1;
                } else {
                    this.filters_count["brands"][product.brand_id]++;
                }

                // COLOR SHADES COUNT
                let color_shades = [];
                product.MainNewSubProducts.forEach((subProduct) => {
                    if (subProduct.Color && subProduct.Color.shades) {
                        let shades = subProduct.Color.shades
                            ? JSON.parse(subProduct.Color.shades)
                            : [];
                        color_shades = color_shades.concat(shades);
                    }
                });
                color_shades = [...new Set(color_shades)];
                color_shades.forEach((shade) => {
                    if (!this.filters_count["colorShades"]) {
                        this.filters_count["colorShades"] = { [shade]: 1 };
                    } else if (!this.filters_count["colorShades"][shade]) {
                        this.filters_count["colorShades"][shade] = 1;
                    } else {
                        this.filters_count["colorShades"][shade]++;
                    }

                    let color_ids = product.MainNewSubProducts.filter(
                        (subProduct) =>
                            subProduct.Color && subProduct.Color.shades == shade
                    ).map((subProduct) => subProduct.color_id);
                    color_ids = [...new Set(color_ids)];

                    color_ids.forEach((colorId) => {
                        if (!this.filters_count["colorShadeColors"]) {
                            this.filters_count["colorShadeColors"] = {
                                [shade]: { [colorId]: 1 }
                            };
                        } else if (
                            !this.filters_count["colorShadeColors"][shade]
                        ) {
                            this.filters_count["colorShadeColors"][shade] = {
                                [colorId]: 1
                            };
                        } else if (
                            !this.filters_count["colorShadeColors"][shade][
                                colorId
                            ]
                        ) {
                            this.filters_count["colorShadeColors"][shade][
                                colorId
                            ] = 1;
                        } else {
                            this.filters_count["colorShadeColors"][shade][
                                colorId
                            ]++;
                        }
                    });
                });

                // SIZES COUNT
                let sizes = product.MainNewSubProducts.map(
                    (subProduct) => subProduct.size_id
                );
                sizes = [...new Set(sizes)];
                sizes.forEach((size) => {
                    if (!this.filters_count["sizes"]) {
                        this.filters_count["sizes"] = { [size]: [product.id] };
                    } else if (!this.filters_count["sizes"][size]) {
                        this.filters_count["sizes"][size] = [product.id];
                    } else {
                        this.filters_count["sizes"][size].push(product.id);
                    }
                });

                // PRICE RANGES COUNT
                this.prod_attr_values.price_ranges.forEach((priceRange) => {
                    if (
                        parseFloat(product.lowest_base_price) >=
                            parseFloat(priceRange.from) &&
                        parseFloat(product.lowest_base_price) <=
                            parseFloat(priceRange.to)
                    ) {
                        if (!this.filters_count["priceRanges"]) {
                            this.filters_count["priceRanges"] = {
                                [priceRange.id]: 1
                            };
                        } else if (
                            !this.filters_count["priceRanges"][priceRange.id]
                        ) {
                            this.filters_count["priceRanges"][
                                priceRange.id
                            ] = 1;
                        } else {
                            this.filters_count["priceRanges"][priceRange.id]++;
                        }
                    }
                });

                // ATTRIBUTES COUNT
                if (product.ProductAttribute) {
                    const attributeOptions = JSON.parse(
                        product.ProductAttribute.attribute_options
                    );
                    attributeOptions.forEach((optionId) => {
                        if (!this.filters_count["attributes"]) {
                            this.filters_count["attributes"] = {
                                [optionId]: 1
                            };
                        } else if (
                            !this.filters_count["attributes"][optionId]
                        ) {
                            this.filters_count["attributes"][optionId] = 1;
                        } else {
                            this.filters_count["attributes"][optionId]++;
                        }
                    });
                }

                // CATEGORIES COUNT
                let category_ids = product.category_ids
                    ? JSON.parse(product.category_ids)
                    : [];
                category_ids.forEach((categoryId) => {
                    if (!this.filters_count["categories"]) {
                        this.filters_count["categories"] = { [categoryId]: 1 };
                    } else if (!this.filters_count["categories"][categoryId]) {
                        this.filters_count["categories"][categoryId] = 1;
                    } else {
                        this.filters_count["categories"][categoryId]++;
                    }
                });
            });
        },

        queryParams(config) {
            let colorShades = config.colorShades
                ? config.colorShades.map((shade) => this.toSnakeCase(shade))
                : [];
            let priceRanges = config.priceRanges
                ? config.priceRanges.map((range) => `${range.from}_${range.to}`)
                : [];
            let updatedParams = {
                attributes: config.attribute_options.join(",") || undefined,
                brands: config.brandIds.join(",") || undefined,
                sizes: config.sizeIds.join(",") || undefined,
                colorShades: colorShades.join(",") || undefined,
                colors: config.colorIds.join(",") || undefined,
                categories: config.categoryIds.join(",") || undefined,
                prices: priceRanges.join(",") || undefined,
                q: this.$router.currentRoute.query.q || undefined,
                pms: config.pms || undefined,
                page: this.currentPage || undefined
            };

            updatedParams = this.removeEmptyKeys(updatedParams);

            return updatedParams;
        },
        prepareQueryParamsOnRoute() {
            let updatedParams = this.queryParams(this.listConfig);
            const currentQuery = { ...this.$route.query };

            const hasDifferentQueryParams =
                JSON.stringify(currentQuery) !== JSON.stringify(updatedParams);
            if (hasDifferentQueryParams) {
                this.$router.replace({
                    name: this.$route.name,
                    params: { ...this.$route.params },
                    query: updatedParams
                });
            }
        },
        onloadPrepareQueryFilters() {
            let queryParams = this.$route.query;
            const resolvedBrandId = Number(this.brand_id);
            const brandIdForFilter = Number.isNaN(resolvedBrandId)
                ? this.brand_id
                : resolvedBrandId;

            let routeBrands = queryParams.brands
                ? queryParams.brands.split(",")
                : [];
            routeBrands = routeBrands.map((attrOption) => parseInt(attrOption));

            let routeCategories = queryParams.categories
                ? queryParams.categories.split(",")
                : [];
            routeCategories = routeCategories.map((attrOption) =>
                parseInt(attrOption)
            );

            let routeColorShades = queryParams.colorShades
                ? queryParams.colorShades.split(",")
                : [];
            routeColorShades = routeColorShades.map((attrOption) =>
                this.toTitleCase(attrOption)
            );

            let routeColors = queryParams.colors
                ? queryParams.colors.split(",")
                : [];
            routeColors = routeColors.map((attrOption) => parseInt(attrOption));

            let routeSizes = queryParams.sizes
                ? queryParams.sizes.split(",")
                : [];
            routeSizes = routeSizes.map((attrOption) =>
                !parseInt(attrOption) ? attrOption : parseInt(attrOption)
            );

            let routePrices = queryParams.prices
                ? queryParams.prices.split(",")
                : [];
            routePrices = routePrices.map((price) => ({
                from: parseFloat(price.split("_")[0]),
                to: parseFloat(price.split("_")[1])
            }));

            let routeAttributeOptions = queryParams.attributes
                ? queryParams.attributes.split(",")
                : [];
            routeAttributeOptions = routeAttributeOptions.map((attrOption) =>
                parseInt(attrOption)
            );

            let routePMS = queryParams.pms || "";

            this.listConfig = {
                offset: (this.currentPage - 1) * this.itemsPerPage,
                limit: this.itemsPerPage,
                sortBy: "",
                order: "ASC",
                brand_id: brandIdForFilter,
                brandIds: routeBrands,
                size_groupings: [],
                colorNames: [],
                sizeIds: routeSizes,
                colorIds: routeColors,
                colorShades: routeColorShades,
                pms: routePMS,
                prod_type_id: this.$route.params.product_type,
                category_id: null,
                categoryIds: routeCategories,
                priceRanges: routePrices,
                sorting: "",
                attribute_options: routeAttributeOptions
            };
        },
        onloadPrepareQueryAppliedFacets() {
            this.applied_filters = [];

            let queryParams = this.$route.query;

            let routeBrands = queryParams.brands
                ? queryParams.brands.split(",")
                : [];
            routeBrands = routeBrands.map((attrOption) => parseInt(attrOption));
            routeBrands.forEach((brandId) => {
                let brand = this.prod_attr_values.brands_list.find(
                    (brand) => brand.id == parseInt(brandId)
                );
                if (brand) {
                    this.applied_filters.push({
                        attribute_id: "Brands",
                        config_type: "brandIds",
                        option_id: brandId,
                        option_label: brand.name
                    });
                }
            });

            let routeCategories = queryParams.categories
                ? queryParams.categories.split(",")
                : [];
            routeCategories = routeCategories.map((attrOption) =>
                parseInt(attrOption)
            );
            routeCategories.forEach((categoryId) => {
                let category = this.prod_attr_values.category_list.find(
                    (category) => category.id == parseInt(categoryId)
                );
                if (category) {
                    this.applied_filters.push({
                        attribute_id: "Categories",
                        config_type: "categoryIds",
                        option_id: categoryId,
                        option_label: category.title
                    });
                }
            });

            let routeColorShades = queryParams.colorShades
                ? queryParams.colorShades.split(",")
                : [];
            routeColorShades = routeColorShades.map((attrOption) =>
                this.toTitleCase(attrOption)
            );
            routeColorShades.forEach((colorShade) => {
                let shade = this.prod_attr_values.color_shades_list.find(
                    (shade) => shade.name == colorShade
                );
                if (shade) {
                    this.applied_filters.push({
                        attribute_id: "ColorShades",
                        config_type: "colorShades",
                        option_id: colorShade,
                        option_label: shade.name
                    });
                }
            });

            let routeSizes = queryParams.sizes
                ? queryParams.sizes.split(",")
                : [];
            routeSizes = routeSizes.map((attrOption) =>
                !parseInt(attrOption) ? attrOption : parseInt(attrOption)
            );
            routeSizes.forEach((sizeId) => {
                let size = this.prod_attr_values.sizes_list.find(
                    (size) => size.id == sizeId
                );
                if (size) {
                    this.applied_filters.push({
                        attribute_id: "Sizes",
                        config_type: "sizeIds",
                        option_id: sizeId,
                        option_label: size.size
                    });
                }
            });

            let routePrices = queryParams.prices
                ? queryParams.prices.split(",")
                : [];
            routePrices = routePrices.map((price) => ({
                from: parseFloat(price.split("_")[0]),
                to: parseFloat(price.split("_")[1])
            }));
            routePrices.forEach((price) => {
                let priceRange = this.prod_attr_values.price_ranges.findIndex(
                    (currentprice) => currentprice.to == price.to
                );
                if (priceRange >= 0) {
                    this.applied_filters.push({
                        attribute_id: "Prices",
                        config_type: "priceRanges",
                        option_id: priceRange,
                        option_label: `$${price.from} - $${price.to}`
                    });
                }
            });

            let routeAttributeOptions = queryParams.attributes
                ? queryParams.attributes.split(",")
                : [];
            routeAttributeOptions = routeAttributeOptions.map((attrOption) =>
                parseInt(attrOption)
            );
            this.prod_attr_values.attributes_list.forEach((attr) => {
                attr.AttributeOptions.forEach((option) => {
                    if (routeAttributeOptions.includes(option.id)) {
                        this.applied_filters.push({
                            attribute_id: `Attribute-${attr.id}`,
                            config_type: "attribute_options",
                            option_id: option.id,
                            option_label: option.category
                        });
                    }
                });
            });

            let routePMS = queryParams.pms || undefined;
            if (routePMS) {
                this.applied_filters.push({
                    attribute_id: "pms",
                    config_type: "pms",
                    option_id: "pms",
                    option_label: routePMS
                });
            }
        },
        getProductAttrIds(productObj) {
            if (
                !this.query_attributes_loaded ||
                !this.listConfig.colorShades.length
            ) {
                productObj.MainNewSubProducts.forEach((subProduct) => {
                    if (subProduct.Color && subProduct.Color.shades) {
                        let shades = subProduct.Color.shades
                            ? JSON.parse(subProduct.Color.shades)
                            : [];
                        shades.forEach((shadeName) => {
                            if (
                                this.filters_count["colorShadeColors"] &&
                                this.filters_count["colorShadeColors"][
                                    shadeName
                                ]
                            ) {
                                subProduct.Color.products_count =
                                    this.filters_count["colorShadeColors"][
                                        shadeName
                                    ][subProduct.color_id] || 0;
                            }
                            const index =
                                this.prod_attr_values.color_shades_list.findIndex(
                                    (shade) => shade.name == shadeName
                                );
                            if (index == -1) {
                                this.prod_attr_values.color_shades_list.push({
                                    id:
                                        this.prod_attr_values.color_shades_list
                                            .length + 1,
                                    name: shadeName,
                                    products_count:
                                        this.filters_count["colorShades"][
                                            shadeName
                                        ] || 0,
                                    colors: [subProduct.Color]
                                });
                            } else {
                                const color_index =
                                    this.prod_attr_values.color_shades_list[
                                        index
                                    ].colors.findIndex(
                                        (color) =>
                                            color.id == subProduct.color_id
                                    );
                                if (color_index == -1) {
                                    this.prod_attr_values.color_shades_list[
                                        index
                                    ].colors.push(subProduct.Color);
                                }
                            }
                        });
                    }
                });
            }

            if (
                !this.query_attributes_loaded ||
                !this.listConfig.sizeIds.length
            ) {
                let size_ids = productObj.MainNewSubProducts.map(
                    (subProduct) => subProduct.size_id
                );
                this.prod_attr_ids.size_ids = [
                    ...new Set(this.prod_attr_ids.size_ids.concat(size_ids))
                ];
            }

            if (
                !this.query_attributes_loaded ||
                !this.listConfig.categoryIds.length
            ) {
                let category_ids = productObj.category_ids
                    ? JSON.parse(productObj.category_ids)
                    : [];
                this.prod_attr_ids.category_ids = [
                    ...new Set(
                        this.prod_attr_ids.category_ids.concat(category_ids)
                    )
                ];
            }

            if (
                !this.query_attributes_loaded ||
                !this.listConfig.size_groupings.length
            ) {
                let size_groupings_ids = productObj.size_groupings
                    ? JSON.parse(productObj.size_groupings)
                    : [];
                this.prod_attr_ids.size_groupings_ids = [
                    ...new Set(
                        this.prod_attr_ids.size_groupings_ids.concat(
                            size_groupings_ids
                        )
                    )
                ];
            }

            if (productObj.ProductAttribute) {
                if (productObj.ProductAttribute.attribute_ids) {
                    let attribute_ids = JSON.parse(
                        productObj.ProductAttribute.attribute_ids
                    );
                    this.prod_attr_ids.attribute_ids = [
                        ...new Set(
                            this.prod_attr_ids.attribute_ids.concat(
                                attribute_ids
                            )
                        )
                    ];
                }
                if (productObj.ProductAttribute.attribute_options) {
                    let attribute_options = JSON.parse(
                        productObj.ProductAttribute.attribute_options
                    );
                    this.prod_attr_ids.attribute_option_ids = [
                        ...new Set(
                            this.prod_attr_ids.attribute_option_ids.concat(
                                attribute_options
                            )
                        )
                    ];
                }
            }
        },
        getProductAttrIdsOld(productObj) {
            let _this = this;

            // Get Size Grouping Ids
            let size_groupings = productObj.size_groupings
                ? this.validJsonParse(productObj.size_groupings)
                : [];
            if (size_groupings.length) {
                if (size_groupings.length > 1) {
                    size_groupings.forEach((sizes) => {
                        _this.insertUniqueValueToArr(
                            _this.prod_attr_ids.size_groupings_ids,
                            sizes.toString()
                        );
                    });
                } else {
                    _this.insertUniqueValueToArr(
                        _this.prod_attr_ids.size_groupings_ids,
                        size_groupings.toString()
                    );
                }
            }
            // Get Sleeves Ids
            _this.insertUniqueValueToArr(
                _this.prod_attr_ids.sleeve_ids,
                productObj.sleeve_id
            );

            // Get Fabric Ids
            let fabric_data = productObj.fabric_ids
                ? this.validJsonParse(productObj.fabric_ids)
                : [];
            if (fabric_data && fabric_data.length) {
                if (fabric_data.length > 1) {
                    fabric_data.forEach((fabric) => {
                        _this.insertUniqueValueToArr(
                            _this.prod_attr_ids.fabric_ids,
                            fabric.id
                        );
                    });
                } else {
                    this.insertUniqueValueToArr(
                        _this.prod_attr_ids.fabric_ids,
                        fabric_data[0].id
                    );
                }
            }
            // Get Other Attributes Ids
            let other_attributes = productObj.other_attributes
                ? this.validJsonParse(productObj.other_attributes)
                : [];
            if (other_attributes && other_attributes.length) {
                if (other_attributes.length > 1) {
                    other_attributes.forEach((sizes) => {
                        _this.insertUniqueValueToArr(
                            _this.prod_attr_ids.other_attributes_ids,
                            sizes.toString()
                        );
                    });
                } else {
                    _this.insertUniqueValueToArr(
                        _this.prod_attr_ids.other_attributes_ids,
                        other_attributes.toString()
                    );
                }
            }
            // Get Styles Ids
            let styles_data = productObj.styles
                ? this.validJsonParse(productObj.styles)
                : [];
            if (styles_data && styles_data.length) {
                if (styles_data.length > 1) {
                    styles_data.forEach((styles) => {
                        _this.insertUniqueValueToArr(
                            _this.prod_attr_ids.styles_ids,
                            styles.id
                        );
                    });
                } else {
                    _this.insertUniqueValueToArr(
                        _this.prod_attr_ids.styles_ids,
                        styles_data[0].id
                    );
                }
            }
        },
        validJsonParse(str) {
            try {
                return JSON.parse(str);
            } catch (e) {
                return false;
            }
        },
        insertUniqueValueToArr(array_data, newValue) {
            if (newValue && !array_data.includes(newValue)) {
                array_data.push(newValue);
            }
        },
        getProductsByFilters(filter_ids) {
            let _this = this;
            _this.listConfig.sleevesId = filter_ids.sleeves_ids;
            _this.listConfig.fabricIds = filter_ids.fabric_ids;
            _this.listConfig.styles = filter_ids.styles_ids;
            _this.listConfig.size_groupings = filter_ids.size_groupings_ids;
            _this.listConfig.other_attributes = filter_ids.other_attributes_ids;
            _this.listConfig.colorIds = filter_ids.color_ids;
            _this.listConfig.colorNames = filter_ids.color_ids;
            _this.refresh_filters_data = false;

            _this.getProducts();
        },
        sizesArrangmentSorting(all_sizes) {
            var all_product_sizes = JSON.parse(
                JSON.stringify(this.shirt_sizes)
            );
            all_sizes.forEach((size) => {
                if (!all_product_sizes.includes(size)) {
                    all_product_sizes.push(size);
                }
            });

            var ar1 = all_product_sizes;
            var ar2 = all_sizes;

            var tmpar = [];
            for (var i = 0; i < ar1.length; i++) {
                if (ar2.indexOf(ar1[i]) !== -1) {
                    tmpar.push(ar1[i]);
                }
            }
            ar1 = tmpar;
            return ar1;
        },
        getAllColors() {
            return new Promise((resolve, reject) => {
                ApiService.post("/all-colors", {
                    attributes: ["id", "name", "hex", "swatches"]
                })
                    .then(({ data }) => {
                        this.all_colors_list = data.colors;
                        resolve(data);
                    })
                    .catch((response) => {
                        console.log(response);
                        reject(response);
                    });
            });
        }
    }
};
</script>
